import { RootActions } from 'types/state';
import * as ActionTypes from './actionTypes';
import { RootActionTypes } from '../actionTypes';

export const submissionTypes = {
  saveAll: 'saveAll',
  saveSignatures: 'saveSignatures',
  submit: 'submit',
  status: 'status'
};

export interface SaveState {
  saved: Date
  isSaving: boolean
  hasError: boolean
  error: any
  errorTime: Date | null
  isSubmitting: boolean
  submissionType: string | null
  submissionHasError: boolean
  submissionError: any
  submissionComplete: boolean
  statusResponse: any
}

export const initialState: SaveState = {
  saved: new Date(),
  isSaving: false,
  error: null,
  errorTime: null,
  hasError: false,
  isSubmitting: false,
  submissionType: '',
  submissionHasError: false,
  submissionError: null,
  submissionComplete: false,
  statusResponse: null,
};

const getSubmissionType = (actionType) => {
  let submissionType = '';
  if (
    [
      ActionTypes.SAVE_ALL_REQUEST,
      ActionTypes.SAVE_ALL_FAILURE,
      ActionTypes.SAVE_ALL_SUCCESS,
    ].includes(actionType)
  ) {
    submissionType = submissionTypes.saveAll;
  } else if (
    [
      ActionTypes.SAVE_SIGNATURES_REQUEST,
      ActionTypes.SAVE_SIGNATURES_FAILURE,
      ActionTypes.SAVE_SIGNATURES_SUCCESS
    ].includes(actionType)
  ) {
    submissionType = submissionTypes.saveSignatures;
  } else if (
    [
      ActionTypes.SUBMIT_REQUEST,
      ActionTypes.SUBMIT_FAILURE,
      ActionTypes.SUBMIT_SUCCESS
    ].includes(actionType)
  ) {
    submissionType = submissionTypes.submit;
  } else if (
    [
      ActionTypes.STATUS_REQUEST,
      ActionTypes.STATUS_FAILURE,
      ActionTypes.STATUS_SUCCESS
    ].includes(actionType)
  ) {
    submissionType = submissionTypes.status;
  }
  return submissionType;
};

const saveReducer = (state: SaveState = initialState, action: RootActions): SaveState => {
  switch (action.type) {
    case ActionTypes.SAVE_REQUEST: {
      return {
        ...state,
        error: null,
        hasError: false,
        isSaving: true,
      };
    }

    case ActionTypes.SAVE_FAILURE: {
      return {
        ...state,
        isSaving: false,
        error: action.payload,
        errorTime: new Date(),
        hasError: true,
      };
    }

    case ActionTypes.SAVE_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        errorTime: null,
        saved: action.payload,
      };
    }

    case ActionTypes.SAVE_CANCELLED: {
      return {
        ...state,
        isSaving: false,
      };
    }

    case ActionTypes.START_SUBMISSION: {
      return {
        ...state,
        isSubmitting: true,
        submissionType: getSubmissionType(action.type),
        submissionHasError: false,
        submissionError: null,
        submissionComplete: false,
        statusResponse: null,
      };
    }

    case ActionTypes.SAVE_ALL_REQUEST:
    case ActionTypes.SAVE_SIGNATURES_REQUEST:
    case ActionTypes.SUBMIT_REQUEST: {
      return {
        ...state,
        isSubmitting: true,
        submissionType: getSubmissionType(action.type),
        submissionHasError: false,
        submissionError: null,
      };
    }

    case ActionTypes.STATUS_REQUEST: {
      return {
        ...state,
        isSubmitting: true,
        submissionType: getSubmissionType(action.type),
        submissionHasError: false,
        submissionError: null,
        statusResponse: null,
      };
    }

    case ActionTypes.SAVE_ALL_FAILURE:
    case ActionTypes.SAVE_SIGNATURES_FAILURE:
    case ActionTypes.SUBMIT_FAILURE:
    case ActionTypes.STATUS_FAILURE: {
      return {
        ...state,
        isSubmitting: false,
        submissionType: getSubmissionType(action.type),
        submissionHasError: true,
        submissionError: action.payload,
      };
    }

    case ActionTypes.SAVE_ALL_SUCCESS:
    case ActionTypes.SAVE_SIGNATURES_SUCCESS:
    case ActionTypes.SUBMIT_SUCCESS: {
      return {
        ...state,
        submissionType: getSubmissionType(action.type),
        submissionHasError: false,
        submissionError: null,
      };
    }

    case ActionTypes.STATUS_SUCCESS: {
      return {
        ...state,
        submissionType: getSubmissionType(action.type),
        submissionHasError: false,
        submissionError: null,
        statusResponse: action.payload,
      };
    }

    case ActionTypes.SUBMISSION_COMPLETE: {
      return {
        ...state,
        isSubmitting: false,
        submissionComplete: true,
      };
    }

    case RootActionTypes.authentication.LOGGED_OFF:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default saveReducer;
